module.exports = __webpack_public_path__ + "static/media/desktopScreenshot06.0073a418.jpg";